import React from "react";
import { PrimaryButton } from "./OnboardingFields";

function WelcomeStep({ termsAccepted, marketingOptIn, onTermsChange, onMarketingChange, onContinue }) {
  return (
    <div className="flex flex-col">
      <div className="flex-1">
        <h1 className="font-logo text-4xl sm:text-5xl md:text-[3.25rem] text-black leading-tight mb-8 sm:mb-10">
          Bienvenue sur
          <br />
          ByeByeRegrets
        </h1>

        <div className="space-y-5 font-josefin text-secondaryText text-sm sm:text-base leading-relaxed max-w-xl">
          <p>
            Pour garantir la livraison de tes lettres en toutes circonstances,
            nous vérifions certaines informations te concernant.
          </p>
          <p>
            Ces informations restent strictement confidentielles, protégées et
            traitées conformément à la réglementation française et européenne.
            Elles servent uniquement au bon fonctionnement du service.
          </p>
          <p>
            Ces vérifications automatisées n&apos;ont aucun impact sur ta vie
            privée ni sur celle de tes proches.
          </p>
        </div>

        <div className="mt-8 sm:mt-10 space-y-4 max-w-xl">
          <label className="flex items-start gap-3 cursor-pointer group">
            <input
              type="checkbox"
              checked={termsAccepted}
              onChange={(e) => onTermsChange(e.target.checked)}
              className="mt-1 h-4 w-4 shrink-0 rounded border-greyLight text-primaryText focus:ring-primaryText accent-primaryText"
            />
            <span className="font-josefin text-sm sm:text-base text-secondaryText leading-snug">
              J&apos;accepte les{" "}
              <a
                href="https://byebyeregrets.fr/legal"
                target="_blank"
                rel="noopener noreferrer"
                className="text-primaryText underline hover:text-primaryDark"
              >
                Conditions Générales d&apos;Utilisation
              </a>
              <span className="text-primaryText">*</span>
            </span>
          </label>

          <label className="flex items-start gap-3 cursor-pointer group">
            <input
              type="checkbox"
              checked={marketingOptIn}
              onChange={(e) => onMarketingChange(e.target.checked)}
              className="mt-1 h-4 w-4 shrink-0 rounded border-greyLight text-primaryText focus:ring-primaryText accent-primaryText"
            />
            <span className="font-josefin text-sm sm:text-base text-secondaryText leading-snug">
              Je souhaite recevoir les actualités et offres de ByeByeRegrets. Je
              peux me désabonner à tout moment.
            </span>
          </label>
        </div>
      </div>

      <div className="mt-10 sm:mt-12 flex justify-end pb-4">
        <PrimaryButton
          variant="purple"
          onClick={onContinue}
          disabled={!termsAccepted}
          className="w-full sm:w-auto"
        >
          Commencer
        </PrimaryButton>
      </div>
    </div>
  );
}

export default WelcomeStep;
